module.exports = __webpack_public_path__ + "img/plan.png";